/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebSettingsEventColorCodingRelayQueryVariables = {};
export type WebSettingsEventColorCodingRelayQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly " $fragmentRefs": FragmentRefs<"EventColoringSettings_org">;
                    } | null;
                } | null> | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"DataSources_user">;
        } | null;
    };
};
export type WebSettingsEventColorCodingRelayQuery = {
    readonly response: WebSettingsEventColorCodingRelayQueryResponse;
    readonly variables: WebSettingsEventColorCodingRelayQueryVariables;
};



/*
query WebSettingsEventColorCodingRelayQuery {
  viewer {
    user {
      ...DataSources_user
      orgs(first: 1000000) {
        edges {
          node {
            id
            ...EventColoringSettings_org
          }
        }
      }
      id
    }
    id
  }
}

fragment DataSource_dataSource on DataSource {
  id
  name
  calendarIds
  syncTargets {
    emailAddress
    calendarId
  }
  state
  type
  username
}

fragment DataSources_user on User {
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        ...DataSource_dataSource
      }
    }
  }
}

fragment EventCategoryColoring_eventCategoryColoring on EventCategoryColoring {
  eventCategory
  googleColorKey
  active
  isUserSet
}

fragment EventCategoryColoring_org on Org {
  id
  primaryOrgCalendar
}

fragment EventColoringSettings_org on Org {
  ...EventCategoryColoring_org
  id
  experiments
  primaryOrgCalendar
  eventColoringSettingsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on EventColoringSettings {
      eventCategoryColorings {
        ...EventCategoryColoring_eventCategoryColoring
        googleColorKey
        eventCategory
        active
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebSettingsEventColorCodingRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "EventColoringSettings_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "DataSources_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WebSettingsEventColorCodingRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "state",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "type",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CrawlTarget",
                                                            "kind": "LinkedField",
                                                            "name": "syncTargets",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "emailAddress",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "username",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventColoringSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "statusCode",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "message",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventCategoryColoring",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventCategoryColorings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventCategory",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "googleColorKey",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "active",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUserSet",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventColoringSettings",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v1 /*: any*/)
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v1 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "38146cbef1fbe6d2bcf46f28ae470bbc",
            "id": null,
            "metadata": {},
            "name": "WebSettingsEventColorCodingRelayQuery",
            "operationKind": "query",
            "text": "query WebSettingsEventColorCodingRelayQuery {\n  viewer {\n    user {\n      ...DataSources_user\n      orgs(first: 1000000) {\n        edges {\n          node {\n            id\n            ...EventColoringSettings_org\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment DataSource_dataSource on DataSource {\n  id\n  name\n  calendarIds\n  syncTargets {\n    emailAddress\n    calendarId\n  }\n  state\n  type\n  username\n}\n\nfragment DataSources_user on User {\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        ...DataSource_dataSource\n      }\n    }\n  }\n}\n\nfragment EventCategoryColoring_eventCategoryColoring on EventCategoryColoring {\n  eventCategory\n  googleColorKey\n  active\n  isUserSet\n}\n\nfragment EventCategoryColoring_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventColoringSettings_org on Org {\n  ...EventCategoryColoring_org\n  id\n  experiments\n  primaryOrgCalendar\n  eventColoringSettingsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        ...EventCategoryColoring_eventCategoryColoring\n        googleColorKey\n        eventCategory\n        active\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f2e991d3947a4896fc8b3c2bf743d66b';
export default node;
